import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Head } from '@inertiajs/react'
import { useForm } from "@inertiajs/react"
import { FormField } from "@/components/core/form_field"
import { Link } from "@inertiajs/react"
import { useState } from "react"

export default function Login({ className, testing = false, ...props }) {
  const { data, setData, post, transform, processing, errors } = useForm({
    email: '',
    password: '',
    password_confirmation: '',
    organization_name: ''
  })

  const [linkedinLoading, setLinkedinLoading] = useState(false)

  const handleSubmit = (event) => {
    event.preventDefault()
    transform(data => ({ user: data }))
    post('/signup?testing=true')
  }

return (
  <>
    <Head>
      <title>founder/mode | Sign Up</title>
    </Head>

    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className={cn("flex flex-col gap-6 p-6 rounded-lg shadow", className)} {...props}>
          <div className="flex flex-col items-center gap-2">
            <Link
              href="#"
              className="flex flex-col items-center gap-2 font-medium"
            >
              <span className="sr-only">founder/mode</span>
            </Link>
            <h1 className="text-2xl font-semibold tracking-tight">Welcome to founder/mode</h1>
            <div className="text-center text-sm text-muted-foreground">
              Already have an account?{" "}
              <Link href="/login" className="underline underline-offset-4 text-foreground">
                Sign in
              </Link>
            </div>
          </div>

          {testing && (
            <>
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-3">
                    <FormField
                      label="Email"
                      name="email"
                      type="email"
                      placeholder="m@example.com"
                      value={data.email}
                      onChange={(e) => setData('email', e.target.value)}
                      errors={errors}
                    />
                    <FormField
                      label="Company Name"
                      name="organization_name"
                      type="text"
                      placeholder="Acme Inc."
                      value={data.organization_name}
                      onChange={(e) => setData('organization_name', e.target.value)}
                      errors={errors}
                    />
                    <FormField
                      label="Password"
                      name="password"
                      type="password"
                      placeholder="********"
                      value={data.password}
                      onChange={(e) => setData('password', e.target.value)}
                      errors={errors}
                    />
                    <FormField
                      label="Password Confirmation"
                      name="password_confirmation"
                      type="password"
                      placeholder="********"
                      value={data.password_confirmation}
                      onChange={(e) => setData('password_confirmation', e.target.value)}
                      errors={errors}
                    />
                  </div>
                  <Button type="submit" className="w-full" disabled={processing}>
                    Sign Up
                  </Button>
                </div>
              </form>
              <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
                <span className="relative z-10 bg-background px-2 text-muted-foreground">
                  Or
                </span>
              </div>
            </>
          )}

          <Button
            onClick={() => { setLinkedinLoading(true); window.location.href = '/auth/linkedin_login' }}
            disabled={linkedinLoading}
            className="w-full"
          >
            {linkedinLoading ? (
              <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
                <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round" />
              </svg>
            ) : (
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
              </svg>
            )}
            {linkedinLoading ? 'Connecting...' : 'Sign up with LinkedIn'}
          </Button>
          <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary  ">
            By clicking continue, you agree to our <a href="#">Terms of Service</a>{" "}
            and <a href="#">Privacy Policy</a>.
          </div>
        </div>
      </div>
    </div>
  </>
  )
}
